import styled from '@emotion/styled';
import { exceptStyledProps, setDeclaration } from '../../utils';
import { SizeType } from '.';

interface Props {
  size?: SizeType;
  color?: string;
}

export const Container = styled('div', exceptStyledProps('color', 'size'))<Props>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  color: ${props => props.color};

  ${props => setDeclaration('width', props.size, 'rem')};
  ${props => setDeclaration('height', props.size, 'rem')};

  svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  circle {
    opacity: 0;
    animation-duration: 1.8s;
    animation-name: opacity, scale;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.3, 0.61, 0.355, 1), cubic-bezier(0.165, 0.84, 0.44, 1);
    transform-origin: 50% 50%;

    & + circle {
      animation-delay: 0.9s;
    }
  }

  @keyframes scale {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes opacity {
    4% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
